import React, { useMemo } from 'react';
import { classNames } from '../tools/helpers';
import Logo from './Logo';
import Button from "./Button";

export default function Footer({ data, className }) {
    const splitDescription = useMemo(
        () => data?.footer_copyright?.description?.split('|') || [],
        [data],
    );

    const splitAdditionalServices = useMemo(
        () => data?.additional_services?.description?.split('|') || [],
        [data],
    );

    const links =
        splitAdditionalServices
            .map((str) => {
                const split = str.split('@');
                if (split.length >= 2) {
                    return {
                        title: split[0],
                        href: split[1],
                    };
                }
                return false;
            })
            .filter(Boolean);

    const contacts = [
        {
            linkUrl: data?.footer_map?.link_url,
            imageSrc: data?.footer_map?.image_src,
            imageAlt: data?.footer_map?.image_alt,
            description: data?.footer_map?.description,
        },
        {
            linkUrl: data?.footer_email?.link_url,
            imageSrc: data?.footer_email?.image_src,
            imageAlt: data?.footer_email?.image_alt,
            description: data?.footer_email?.description,
        },
    ];
    const socials = [
        {
            linkUrl: data?.footer_twitter?.link_url,
            imageSrc: data?.footer_twitter?.image_src,
            imageAlt: data?.footer_twitter?.image_alt,
            description: data?.footer_twitter?.description,
        },
        {
            linkUrl: data?.footer_facebook?.link_url,
            imageSrc: data?.footer_facebook?.image_src,
            imageAlt: data?.footer_facebook?.image_alt,
            description: data?.footer_facebook?.description,
        },
        {
            linkUrl: data?.footer_linkedin?.link_url,
            imageSrc: data?.footer_linkedin?.image_src,
            imageAlt: data?.footer_linkedin?.image_alt,
            description: data?.footer_linkedin?.description,
        },
        {
            linkUrl: data?.footer_instagram?.link_url,
            imageSrc: data?.footer_instagram?.image_src,
            imageAlt: data?.footer_instagram?.image_alt,
            description: data?.footer_instagram?.description,
        },
    ];

    return (
        <div
            className={classNames(
                'flex flex-col items-center',
                className,
            )}
        >
            <div className={'flex flex-col gap-y-8 items-center'}>
                <div className={'font-bold max-w-[652px] text-3xl text-center text-white z-20 sm:leading-[56px] sm:text-5xl'}>
                    {data?.footer?.description}
                </div>
                <Button
                    className={
                        'text-sm w-fit z-20 sm:leading-6 sm:text-base'
                    }
                    type="a"
                    href={data?.footer_button?.link_url}
                    target="_blank"
                >
                    {data?.footer_button?.description}
                </Button>
                <img src={data?.footer?.image_src} alt={data?.footer?.image_alt} className={'absolute hidden md:top-[134px] z-0 md:block'}/>
            </div>
            <div className={'flex flex-col-reverse gap-y-8 mt-[100px] w-full md:flex-row sm:justify-between md:mt-[338px]'}>
                <div className={'space-y-4 !text-white'}>
                    <Logo />
                    <p className={'text-sm mt-8 sm:leading-7 sm:text-base'}>
                        {splitDescription.length >= 1 && splitDescription[0]}{' '}
                        {new Date().getFullYear()}{' '}
                        {splitDescription.length >= 2 && splitDescription[1]}
                    </p>
                    <ul className={'flex gap-4'}>
                        {socials.map((social, index) => (
                            <a
                                key={index}
                                href={social.linkUrl}
                                className={'bg-primary-green-102 flex h-10 items-center justify-center rounded-full w-10'}
                            >
                                <img src={social.imageSrc} alt={social.imageAlt} />
                            </a>
                        ))}
                    </ul>
                </div>
                <div className={'space-y-4 sm:space-y-6'}>
                    <p className={'font-bold text-base text-white sm:text-xl'}>{data?.additional_services?.title}</p>
                    <ul
                        className={
                            'leading-[28px] m-0 p-0 space-y-2 sm:space-y-4'
                        }
                    >
                        {links.map((link, index) => (
                            <li
                                key={index}
                                className={'flex items-center gap-4 sm:gap-6'}
                            >
                                <a
                                    href={link.href}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={'!no-underline'}
                                >
                                    <span className={'text-sm text-primary-gray-101 text-nowrap sm:text-base'}>
                                        {link.title}
                                    </span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <ul className={'space-y-4 sm:space-y-8'}>
                    {contacts.map((contact, index) => (
                        <li key={index} className={'flex gap-4 items-start sm:gap-6'}>
                            <a
                                href={contact.linkUrl}
                            >
                                <div className={'bg-primary-green-102 flex h-10 items-center justify-center rounded-full w-10'}>
                                    <img
                                        src={contact.imageSrc}
                                        alt={contact.imageAlt}
                                    />
                                </div>
                            </a>
                            <span className={'mt-1.5 text-sm text-primary-gray-101 text-justify sm:w-[266px] sm:leading-7 sm:text-base'}>
                                {contact.description}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
